import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import { getPaymentsForProgramInitiate } from '../../../actions/programs';
import GiftingProgramPaymentTable from './GiftingProgramPaymentTable';
import { currentFlowTypeEnum } from '../../common/components/constants';

const mapStateToProps = state => {
  const programPayments = _get(state, 'programs.programPayments', {});
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const viewOnlyMode = _get(state, 'user.view_only_mode', false);
  const currentFlow = currentFlowTypeEnum.FLOW_TYPE_GIFT_CARD;

  return {
    currentFlow,
    viewOnlyMode,
    selectedWorkspace,
    fetchingProgramPayments:
      _get(state, 'apiState.GET_PAYMENTS_FOR_PROGRAM.isFetching', true) &&
      !_get(state, 'apiState.GET_PAYMENTS_FOR_PROGRAM.isIdle', false),
    fetchedProgramPayments: _get(
      state,
      'apiState.GET_PAYMENTS_FOR_PROGRAM.success',
      true,
    ),
    programPayments,
  };
};

const mapDispatchToProps = dispatch => ({
  getPaymentsForProgram: payload =>
    dispatch(getPaymentsForProgramInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GiftingProgramPaymentTable);
